import type { DateRange } from "@/models/common";

export interface FilterState {
  dateRange: DateRange | undefined;
  filters: Array<string>;
  isFilterShareable: boolean;
}

/**
 * Create a state object for the filter module.
 * @returns A state object initialized for use in the filters' module.
 */
export function makeState(): FilterState {
  return {
    dateRange: undefined,
    filters: [],
    isFilterShareable: false,
  };
}
